import React from "react";
import { Box, Grid, Container } from "@mui/material";
// import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


const specail1 = "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/2ytV5vCMfTE6VuThnHXsb0tvRKOumfyPUtwUS37K.jpg"
const specail3 = "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/9gRslu7Zz1hWWa3awkTkT1OG6oLxnNO0gpmIpMDo.jpg"
const specail2 = "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/WmGM7O9imbOJLrcPlDaSu0UqkxNrjd6e2g7YHLpX.jpg"

const SpecailDiscountComponent = () => {
  // const categoriesId = useSelector((state) => state?.Dashboard?.categories)

  const SpecailId1 = 'e-commerce'
  const SpecailId2 = "apparel"
  const SpecailId3 = "entertainment"

  const navigate = useNavigate();
  const link = (slug) => ({
    pathname: '/card-list',
    search: `categorySlug=${slug}`,
  });
  return (
    <Container maxWidth="xl" sx={{ py: { xs: 1, md: 4 }, mt: 5 }} disableGutters>
      <Grid
        container
        spacing={{ xs: 0.5, md: 1.6 }}
        alignItems="stretch"
        wrap="nowrap"
        sx={{
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >

        {/* Right Column bigger image */}
        <Grid
          item
          xs={12}
          md={7}
          display="flex"
          order={{
            xs: 1,
            md: 2,
          }}
        >
          <Box
            onClick={() => navigate(link(SpecailId1))}
            component="img"
            src={specail1}
            alt="Specail Image"
            sx={{
              width: "100%",
              height: "auto",
              objectFit: "contain",
              borderRadius: { xs: "5px", md: "12px" },
              cursor: "pointer"
            }}
          />
        </Grid>

        {/* Left Column images */}
        <Grid
          item
          xs={12}
          md={5}
          display="flex"
          padding={{ xs: 0.6, md: 0 }}
          gap={{ xs: 0.5, sm: 0.5, md: 0.8, lg: 1.5 }}
          flexDirection={{
            xs: "row",
            md: "column",
          }}
          order={{
            xs: 2,
            md: 1,
          }}
        >
          <Box
            onClick={() => navigate(link(SpecailId3))}
            component="img"
            src={specail3}
            alt="Croma Sale"
            sx={{
              width: {
                xs: "50%",
                md: "100%",
              },
              height: "auto",
              objectFit: "contain",
              borderRadius: { xs: "5px", md: "12px" },
              cursor: "pointer"
            }}
          />
          <Box
            onClick={() => navigate(link(SpecailId2))}
            component="img"
            src={specail2}
            alt="Lifestyle Sale"
            sx={{
              width: {
                xs: "50%",
                md: "100%",
              },
              height: "auto",
              objectFit: "contain",
              borderRadius: { xs: "5px", md: "12px" },
              cursor: "pointer"
            }}
          />
        </Grid>

      </Grid>
    </Container>
  );
};

export default SpecailDiscountComponent;